import React from 'react';

import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const SubmissionError = ({ message }) => {
  if (!message) return null;

  return (
    <div
      role="alert"
      className="flex w-full items-start gap-2 rounded-lg border border-solid border-danger-200 bg-danger-50 p-3">
      <Icon icon="info-circle-filled" color="danger" size={18} />
      <Typography variant="p" size="small" color="danger-700" className="!block w-full">
        {message}
      </Typography>
    </div>
  );
};

export default SubmissionError;
